import { ReactNode } from "react";
import { Link } from "react-router";

import { usePageContext } from "@digital-services/shell";
import { Breadcrumbs } from "@digital-services/ui";

interface Breadcrumb {
  id: string;
  content: ReactNode;
}

export const NavBreadcrumbs = () => {
  const { breadcrumbs } = usePageContext();

  const items: Breadcrumb[] = breadcrumbs.map((breadcrumb, index) => {
    return {
      id: index.toString(),
      content: <Link to={breadcrumb.path}>{breadcrumb.label}</Link>
    };
  });

  return <Breadcrumbs breadcrumbs={items} />;
};
